import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(VBreadcrumbs, {
        staticClass: "d-print-none",
        attrs: { items: _vm.breadCombs },
      }),
      _c(VDivider, { staticClass: "mx-4 d-print-none" }),
      _c(
        VRow,
        { staticClass: "d-print-none" },
        [
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "5" } },
            [
              _c(
                "div",
                { staticClass: "title ml-6", on: { click: _vm.showBaseInfo } },
                [
                  _vm._v(
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.labelDetail.baseInfo"))
                  ),
                ]
              ),
              _c(
                VBanner,
                {
                  attrs: {
                    "single-line": "",
                    transition: "slide-y-transition",
                  },
                  model: {
                    value: _vm.baseInfo,
                    callback: function ($$v) {
                      _vm.baseInfo = $$v
                    },
                    expression: "baseInfo",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "6", md: "3" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.labelDetail.codePrefix"
                              ),
                            },
                            model: {
                              value: _vm.label.prefix,
                              callback: function ($$v) {
                                _vm.$set(_vm.label, "prefix", $$v)
                              },
                              expression: "label.prefix",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "6", md: "3" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.labelDetail.code"
                              ),
                            },
                            model: {
                              value: _vm.label.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.label, "code", $$v)
                              },
                              expression: "label.code",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "6", md: "6" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.labelDetail.stockDate"
                              ),
                              readonly: "",
                            },
                            model: {
                              value: _vm.label.stockDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.label, "stockDate", $$v)
                              },
                              expression: "label.stockDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(VDivider, { staticClass: "mx-4", attrs: { vertical: "" } }),
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "6" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.items,
                  label: _vm.$vuetify.lang.t("$vuetify.printSetting.title"),
                },
                on: { change: _vm.change },
                model: {
                  value: _vm.label.printSettingId,
                  callback: function ($$v) {
                    _vm.$set(_vm.label, "printSettingId", $$v)
                  },
                  expression: "label.printSettingId",
                },
              }),
              _c(
                VBanner,
                {
                  attrs: {
                    "single-line": "",
                    transition: "slide-y-transition",
                  },
                  model: {
                    value: _vm.printSetting,
                    callback: function ($$v) {
                      _vm.printSetting = $$v
                    },
                    expression: "printSetting",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.left"
                              ),
                            },
                            model: {
                              value: _vm.label.print.left,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "left", $$v)
                              },
                              expression: "label.print.left",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.right"
                              ),
                            },
                            model: {
                              value: _vm.label.print.right,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "right", $$v)
                              },
                              expression: "label.print.right",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.top"
                              ),
                            },
                            model: {
                              value: _vm.label.print.top,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "top", $$v)
                              },
                              expression: "label.print.top",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.bottom"
                              ),
                            },
                            model: {
                              value: _vm.label.print.bottom,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "bottom", $$v)
                              },
                              expression: "label.print.bottom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.qrSize"
                              ),
                            },
                            model: {
                              value: _vm.label.print.qrSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "qrSize", $$v)
                              },
                              expression: "label.print.qrSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.fontSize"
                              ),
                            },
                            model: {
                              value: _vm.label.print.fontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "fontSize", $$v)
                              },
                              expression: "label.print.fontSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", sm: "2", md: "2" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$vuetify.lang.t(
                                "$vuetify.printSetting.cols"
                              ),
                            },
                            model: {
                              value: _vm.label.print.cols,
                              callback: function ($$v) {
                                _vm.$set(_vm.label.print, "cols", $$v)
                              },
                              expression: "label.print.cols",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "d-print-none" },
        [
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "10" } },
            [
              _c(
                VBtnToggle,
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "indigo white--text",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.dialog = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.add")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VDialog,
                    {
                      attrs: { "max-width": "290" },
                      model: {
                        value: _vm.dialog,
                        callback: function ($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog",
                      },
                    },
                    [
                      _c(
                        VCard,
                        [
                          _c(VCardTitle, { staticClass: "headline" }, [
                            _vm._v(
                              _vm._s(_vm.$vuetify.lang.t("$vuetify.base.add"))
                            ),
                          ]),
                          _c(
                            VCardActions,
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$vuetify.lang.t(
                                    "$vuetify.labelDetail.weight"
                                  ),
                                  "error-messages": _vm.errorMessage,
                                  required: "",
                                },
                                model: {
                                  value: _vm.addWeight,
                                  callback: function ($$v) {
                                    _vm.addWeight = $$v
                                  },
                                  expression: "addWeight",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.dialog = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.cancel")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.addWeightFunc.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.confirm")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "success white--text",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.save.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.save")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", sm: "12", md: "2" } },
            [
              _c(
                VBtnToggle,
                [
                  _c(
                    VBtn,
                    {
                      directives: [
                        {
                          name: "print",
                          rawName: "v-print",
                          value: _vm.printObj,
                          expression: "printObj",
                        },
                      ],
                      staticClass: "primary white--text",
                      attrs: { small: "" },
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.printSetting.print")
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.delete"))),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.cancel")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.deleteWeightConfirm },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.confirm")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDivider, { staticClass: "d-print-none" }),
      _c(
        "vuedraggable",
        { attrs: { list: _vm.label.weightInfoList } },
        [
          _c(
            "transition-group",
            { staticClass: "row" },
            _vm._l(_vm.label.weightInfoList, function (weight, index) {
              return _c(
                VCol,
                {
                  key: _vm.label.id + "_" + index,
                  class: weight.checked ? "" : "d-print-none",
                  style: {
                    paddingTop: _vm.label.print.top + "px",
                    paddingRight: _vm.label.print.right + "px",
                    paddingBottom: _vm.label.print.bottom + "px",
                    paddingLeft: _vm.label.print.left + "px",
                    fontSize: _vm.label.print.fontSize + "pt",
                  },
                  attrs: { cols: "12", sm: "6", md: 12 / _vm.label.print.cols },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "5px" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: weight.checked,
                            expression: "weight.checked",
                          },
                        ],
                        staticClass: "d-print-none",
                        staticStyle: { "margin-right": "2px" },
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(weight.checked)
                            ? _vm._i(weight.checked, null) > -1
                            : weight.checked,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = weight.checked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(weight, "checked", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    weight,
                                    "checked",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(weight, "checked", $$c)
                            }
                          },
                        },
                      }),
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Bergsoe Metals Co. Ltd."),
                      ]),
                      _c(
                        VIcon,
                        {
                          staticClass: "d-print-none",
                          staticStyle: { "margin-left": "5px", color: "blue" },
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.deleteWeight(weight.index)
                            },
                          },
                        },
                        [_vm._v("delete ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "flex-direction": "row" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", clear: "both" },
                          style: { width: _vm.label.print.qrSize + "px" },
                        },
                        [
                          _vm.companyName.startsWith("Bergsoe")
                            ? _c("img", {
                                staticStyle: {
                                  position: "absolute",
                                  clear: "both",
                                },
                                style: {
                                  width: _vm.label.print.qrSize / 5 + "px",
                                  marginTop:
                                    (_vm.label.print.qrSize / 10) * 4 + "px",
                                  marginLeft:
                                    (_vm.label.print.qrSize / 10) * 4 + "px",
                                },
                                attrs: { src: require("../assets/logo.png") },
                              })
                            : _c("img", {
                                staticStyle: {
                                  position: "absolute",
                                  clear: "both",
                                },
                                style: {
                                  width: _vm.label.print.qrSize / 5 + "px",
                                  marginTop:
                                    (_vm.label.print.qrSize / 10) * 4 + "px",
                                  marginLeft:
                                    (_vm.label.print.qrSize / 10) * 4 + "px",
                                },
                                attrs: {
                                  src: require("../assets/panya-logo.png"),
                                },
                              }),
                          _c("qriously", {
                            attrs: {
                              value:
                                _vm.label.productName +
                                ";" +
                                _vm.label.stockDate +
                                ";" +
                                _vm.label.prefix +
                                "-" +
                                _vm.label.code +
                                "-" +
                                weight.index +
                                ";" +
                                weight.weight,
                              size: _vm.label.print.qrSize,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "margin-left": "10px" } },
                        [
                          _vm._v(" " + _vm._s(_vm.label.productName)),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(_vm.label.prefix) +
                              "-" +
                              _vm._s(_vm.label.code) +
                              "-" +
                              _vm._s(weight.index)
                          ),
                          _c("br"),
                          _vm._v(" " + _vm._s(_vm.label.stockDate)),
                          _c("br"),
                          weight.editFlag
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: weight.weight,
                                    expression: "weight.weight",
                                  },
                                ],
                                staticStyle: { "border-radius": "10px" },
                                attrs: { type: "nubmer" },
                                domProps: { value: weight.weight },
                                on: {
                                  blur: function ($event) {
                                    return _vm.weightChange(weight.index)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      weight,
                                      "weight",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(weight.weight) + "kg"),
                              ]),
                          _c(
                            VIcon,
                            {
                              staticClass: "d-print-none",
                              staticStyle: {
                                "margin-left": "5px",
                                color: "blue",
                              },
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.weightEdit(weight.index)
                                },
                              },
                            },
                            [_vm._v("edit ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }